"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var applyClassName_1 = __importDefault(require("./applyClassName"));
var responsiveClassNames = function (
// Object with classNames from CSS Modules
s, 
// className to be used responsively
className, 
// Object with responsive values
value) {
    if (typeof value !== "object") {
        var staticClassName = (0, applyClassName_1.default)(className, value);
        return staticClassName ? s[staticClassName] : null;
    }
    var viewports = Object.keys(value);
    var responsiveClassNamesArr = viewports.reduce(function (acc, viewport) {
        var viewportClassName = (0, applyClassName_1.default)(className, value[viewport], { viewport: viewport });
        if (!viewportClassName)
            return acc;
        return __spreadArray(__spreadArray([], acc, true), [s[viewportClassName]], false);
    }, []);
    return responsiveClassNamesArr.join(" ");
};
exports.default = responsiveClassNames;
